export default __webpack_public_path__ + "static/media/frame_zh_cn_pc.39697f66.png";